module.exports = __webpack_public_path__ + "img/Wordpress_Logo.10babc95.svg";